const styles = {
    container: {
        alignItems: 'stretch',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    iframe: {
        marginTop: 0,
        width: '100%',
    },
    playButton: {
        alignSelf: 'center',
        color:'#FFFFFF',
        fontSize: 114,
    },
    videoBackgroundImage: {
        alignItems: 'center',
        backgroundImage: 'url(http://via.placeholder.com/300x150)',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        display: 'flex',
        flexDirection: 'row',
        height: 300,
        justifyContent: 'center',
    },
    videoCaption: {
        color: '#000000',
        fontFamily: 'arial',
        fontSize: 20,
        marginTop: 5,
    },
}

Object.freeze(styles);

export { styles as stretchVideoStyles };


// WEBPACK FOOTER //
// ./src/js/components/StretchVideo/styles.ts